import { getRestartVerificationRequest } from './requestCreator';
import { postRequest } from './AxiosClient';

export const restartVerification = async (channel) => {
  const { url, headers } = getRestartVerificationRequest(channel);
  return postRequest(url, headers)
    .then((response) => {
      if (
        response?.status == 200 &&
        typeof response.data === 'object' &&
        response?.data?.militaryDiscount
      )
        return { response };
      return { error: true };
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(
        'Error calling restart verification API, in restartVerification()',
      );
      return { error: true };
    });
};
